// extracted by mini-css-extract-plugin
export default {"container":"style_container__7Y6GZ","searchBarWrapper":"style_searchBarWrapper__sO7MX"};